import { formatDateForInput } from "@/shared/lib/date-time";
import type { AuditPlanFormValues } from "./AuditPlanForm";

export const auditPlanFormSamples: AuditPlanFormValues[] = [
  {
    name: "ຜະແນການກວດສອບຄຸນນະພາບການຜະລິດ",
    description:
      "ຜະແນການກວດສອບຄຸນນະພາບຂອງຂະບວນການຜະລິດສິນຄ້າ ການຄວບຄຸມຄຸນນະພາບ ແລະ ການປະຕິບັດຕາມມາດຕະຖານ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "monthly",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    ),
    status: "pending",
    isActive: true,
  },
  {
    name: "ຜະແນການກວດສອບຄວາມປອດໄພໃນການເຮັດວຽກ",
    description:
      "ຜະແນການກວດສອບຄວາມປອດໄພໃນສະຖານທີ່ເຮັດວຽກ ການປະຕິບັດຕາມມາດຕະຖານຄວາມປອດໄພ ແລະ ການປ້ອງກັນອຸບັດຕິເຫດ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "quarterly",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 90 * 24 * 60 * 60 * 1000),
    ),
    status: "pending",
    isActive: true,
  },
  {
    name: "ຜະແນການກວດສອບການບໍລິຫານຄັງເກັບສິນຄ້າ",
    description:
      "ຜະແນການກວດສອບການຈັດການຄັງເກັບສິນຄ້າ ການບັນຈຸ ການຄຸ້ມຄອງສິນຄ້າຄົງຄັງ ແລະ ການຄວບຄຸມສະຕ໋ອກ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "monthly",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
    ),
    status: "in_progress",
    isActive: true,
  },
  {
    name: "ຜະແນການກວດສອບການບໍລິຫານເອກະສານ",
    description:
      "ຜະແນການກວດສອບການຈັດການເອກະສານ ການບັນທຶກ ການເກັບຮັກສາເອກະສານທາງການ ແລະ ການຄວບຄຸມເອກະສານ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "semi_annual",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
    ),
    status: "pending",
    isActive: true,
  },
  {
    name: "ຜະແນການກວດສອບການບໍລິຫານງົບປະມານ",
    description:
      "ຜະແນການກວດສອບການຈັດການງົບປະມານ ການບັນທຶກລາຍຈ່າຍ ການຄຸ້ມຄອງທຶນ ແລະ ການຄວບຄຸມງົບປະມານ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "annual",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
    ),
    status: "pending",
    isActive: true,
  },
  {
    name: "ຜະແນການກວດສອບການບໍລິການລູກຄ້າ",
    description:
      "ຜະແນການກວດສອບຄຸນນະພາບການບໍລິການລູກຄ້າ ການຕອບສະໜອງຄວາມຕ້ອງການ ແລະ ຄວາມພໍໃຈຂອງລູກຄ້າ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "quarterly",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 60 * 24 * 60 * 60 * 1000),
    ),
    status: "pending",
    isActive: true,
  },
  {
    name: "ຜະແນການກວດສອບການບໍລິຫານຊັບພະຍາກອນມະນຸດ",
    description:
      "ຜະແນການກວດສອບການຈັດການຊັບພະຍາກອນມະນຸດ ການບັນທຶກຂໍ້ມູນພະນັກງານ ແລະ ການຄວບຄຸມຂະບວນການຈ້າງງານ",
    auditTypeId: "",
    sopId: "",
    qcStandardId: "",
    departmentId: "",
    auditorPositionId: "",
    frequency: "semi_annual",
    nextAuditDate: formatDateForInput(
      new Date(Date.now() + 120 * 24 * 60 * 60 * 1000),
    ),
    status: "pending",
    isActive: true,
  },
];
